import { VHCRecordLabourInput, VhcRecordLogService } from 'api/generated';
import { ApiMutationOptions, useMutationWithNotifications } from 'api/utils/useMutationWithNotifications';

export type CreateWheelLabourInput = {
  logId: number;
  itemId: number;
  requestBody?: VHCRecordLabourInput;
};

export const useSaveWheelLabourMutation = (
  options?: ApiMutationOptions<typeof VhcRecordLogService.postVhcRecordsItemsWheelTyresLabours, CreateWheelLabourInput>
) =>
  useMutationWithNotifications(
    ({ logId, itemId, requestBody }: CreateWheelLabourInput) =>
      VhcRecordLogService.postVhcRecordsItemsWheelTyresLabours(logId, itemId, requestBody),
    options
  );
